import { Text } from '@mantine/core';
import type { ReactNode } from 'react';

interface LandingSectionLabelProps {
  readonly children: ReactNode;
}

// Подпись над заголовком раздела стартовой: зелёный текст без подложки, чтобы не походить на кнопку.
export default function LandingSectionLabel({ children }: LandingSectionLabelProps) {
  return (
    <Text c="brand.7" fw={600} fz="sm">
      {children}
    </Text>
  );
}
